module.exports = __webpack_public_path__ + "static/media/notificationBell.98713ec5.svg";